module.exports = __webpack_public_path__ + "static/media/thumb_1.52a1895f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Images/thumb_1.png
// module id = 74
// module chunks = 0